import React from "react";
import { Popconfirm } from "antd";
import GainIcon from "../gainicon";

export default function DeleteButton(props) {
  return (
    <Popconfirm
      title="Are you sure to delete this user?"
      onConfirm={props.onClick}
    //   onCancel={cancel}
      okText="Yes"
      cancelText="No"
    >
     <a href="#">
     <GainIcon name="delete" />
     </a>
    </Popconfirm>
  );
}
